module.exports = __webpack_public_path__ + "static/media/back.8f8b5082.svg";